// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DonationForm_wrapper__2_IMn","title":"DonationForm_title__TNwCY","subtitle":"DonationForm_subtitle__sPr1Y","btn":"DonationForm_btn__rxZMU"};